import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { EnergyResourceService } from 'src/app/providers/energy-resource/energy-resource.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';

@Component({
  selector: 'app-visa-modal',
  templateUrl: './visa-modal.component.html',
  styleUrls: ['./visa-modal.component.scss']
})
export class VisaModalComponent implements OnInit {
  @Input() header;
  @Input() empId;
  visaForm: FormGroup;
  loading = false;
  submitted = false;
  constructor(
    private erService : EnergyResourceService,
    private notifyService : NotificationService,
  ) { }

  ngOnInit(): void {
    this.visaForm = new FormGroup({
      id : new FormControl('')
    });
  }

  onSubmitVisa(): void {

  }

  onReset(): void {
    this.visaForm.reset();
  }

}
